import {dashboardView, DashboardView} from "./view/DashboardViewComponent";

import Components from "./components";
import Dialogs from "./dialog";
import Pipes from "./pipes";
import Services from "./service";
import {DashboardViewStore} from "./store/DashboardViewStore";
import {desktopView, DesktopView} from "./view/desktop/DashboardDesktopViewComponent";
import {mobileView, MobileView} from "./view/mobile/DashboardMobileViewComponent";

export default function() {
    return angular.module("tfApp.dashboard.oms", [Components(), Dialogs(), Pipes(), Services()])
                  .component(DashboardView, dashboardView())
                  .component(DesktopView, desktopView())
                  .component(MobileView, mobileView())
                  .service(DashboardViewStore.id, DashboardViewStore)
                  .name;
}
